import {
  coverageRSExtendedForcedStates,
  coverageRSForcedStates,
  extendedCoverageRSExpirationByAgeStateExclusions,
  noShowRoofSurfacesExtendedUnderXYearsStates
} from '@ourbranch/roof-helpers';

export const getForcedExtendedRSCoverage = (state, roofAge, stateOverride, stateSpecificRoofSurfacesExtended) => {
  // determines if we should force extended roof coverage

  if (stateOverride) {
    return stateSpecificRoofSurfacesExtended;
  }

  return (
    // forced extended states
    coverageRSExtendedForcedStates[state] ||
    // special states where the option is binary, either force extended or schedule
    (noShowRoofSurfacesExtendedUnderXYearsStates[state] &&
      roofAge <= noShowRoofSurfacesExtendedUnderXYearsStates[state])
  );
};

export const getForcedScheduleRSCoverage = (
  state,
  coverageRSExtended,
  fromPolicy,
  roofAge,
  roofAgeLimit,
  stateOverride,
  stateSpecificRoofSurfacesExtended
) => {
  // determines if we should force roof schedule coverage

  if (stateOverride) {
    return !stateSpecificRoofSurfacesExtended;
  }

  return (
    // force if in list
    coverageRSForcedStates[state] ||
    // these states always have the option for extended coverage since it never expires
    (!extendedCoverageRSExpirationByAgeStateExclusions[state] &&
      // if already bound with extended and in this list, dont force, we need to honor policies with extended even if it is wrong by our logic
      !(fromPolicy && noShowRoofSurfacesExtendedUnderXYearsStates[state] && coverageRSExtended) &&
      // check the age limits
      roofAge > roofAgeLimit)
  );
};

export const shouldFieldBeLocked = (
  fromPolicy,
  state,
  isCurrentValueCorrectValueInPolicy,
  inPolicyAndRoofYearUnchanged,
  policyBoundWithRoofExtendedSoWeHaveToHonorIt,
  forcedScheduledRSCoverage,
  forcedExtendedRSCoverage,
  stateOverride,
  stateSpecificLockField
) => {
  // we need to lock the roof coverage field to prevent confusion and wrong coverage selection

  // but not if we have the wrong value, because we want to allow a user to switch to the cheaper coverage
  if (policyBoundWithRoofExtendedSoWeHaveToHonorIt && !isCurrentValueCorrectValueInPolicy) {
    return false;
  }

  if (stateOverride) {
    return stateSpecificLockField;
  }

  if (noShowRoofSurfacesExtendedUnderXYearsStates[state]) {
    // always locks for these since its one or the other determined by the roof age
    return true;
  }

  return fromPolicy &&
    // check if the value is what we expect, if not then we are most likely in a policy that was bound like this
    // so we dont lock the field in order to let the user change it if they want
    !isCurrentValueCorrectValueInPolicy &&
    inPolicyAndRoofYearUnchanged
    ? false
    : forcedScheduledRSCoverage || forcedExtendedRSCoverage || false;
};
